"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = require("../constants/theme");
const create_styles_1 = require("../utils/create-styles");
const styled_system_1 = require("../utils/styled-system");
const Text = (props) => {
    const { bold, children, color, size, noSelect } = props;
    const TextElement = (0, styled_1.default)(bold ? 'strong' : 'span')({
        ...(0, styled_system_1.display)(props),
        ...(0, styled_system_1.opacity)(props),
        ...(0, styled_system_1.space)(props),
        ...(0, styled_system_1.typography)(props),
        ...(size !== undefined &&
            (0, styled_system_1.fontSize)({
                fontSize: Array.isArray(size)
                    ? size.map((s) => theme_1.theme.font.size[s])
                    : theme_1.theme.font.size[size],
            })),
        color,
        maxWidth: props.noWrap ? '100%' : undefined,
        overflow: props.noWrap && !props.noEllipsis ? 'hidden' : undefined,
        textDecoration: props.textDecoration,
        textOverflow: props.noWrap ? 'ellipsis' : undefined,
        whiteSpace: props.noWrap ? 'nowrap' : undefined,
        userSelect: noSelect ? 'none' : undefined,
        ...(0, create_styles_1.createStyles)(props.styles),
    });
    return (0, jsx_runtime_1.jsx)(TextElement, { className: props.className, children: children });
};
exports.Text = Text;
